import React from "react"

export default function Quiz({ question, current, total, onSelect, onBack }) {
  const progress = (current / total) * 100

  return (
    <div>
      <div className="progress-row">
        <span className="progress-label">
          Question {current + 1} of {total}
        </span>
      </div>

      <div className="progress-track">
        <div className="progress-fill" style={{ width: `${progress}%` }} />
      </div>

      <h2 className="q-title">{question.title}</h2>

      <div className="options">
        {question.options.map((option) => (
          <button
            className="option"
            key={option.text}
            onClick={() => onSelect(option)}
          >
            {option.text}
          </button>
        ))}
      </div>

      <div className="nav-row">
        <button
          className="back-link"
          onClick={onBack}
          disabled={current === 0}
        >
          ← Back
        </button>
      </div>
    </div>
  )
}
